import { axiosGet, axiosPost, handleOnError } from '../utils/api';

class MerchantService {
  async fetch(date,params={}) {
    if (date) {
      try{
        let response = await axiosGet(`excel/fetch/${date}`,params)
        return response.data
      }catch(error){
          return await handleOnError(error);
      }
    } else {
      try{
        let response = await axiosGet(`excel/fetch`)
        return response.data
      }catch(error){
          return await handleOnError(error);
      }
    }
  }
  async fetchById(id) {
      try{
        let response = await axiosGet(`excel/fetch/id/${id}`)
        return response.data
      }catch(error){
          return await handleOnError(error);
      }
   
  }
  async uploadFile(data){
    try{
      let response = await axiosPost('excel/upload',data)
      return response.data
    }catch(error){
      return await handleOnError(error);
    }
  }
  async getFiles(params={}){
    try{
      let response = await axiosGet('excel/files',params)
      return response.data
    }catch(error){
        return await handleOnError(error);
    }
  }
  async deleteFile(data){
    try{
      let response = await axiosPost('excel/delete',data)
      return response.data
    }catch(error){
      return await handleOnError(error);
    }
  }
}

export default new MerchantService();